import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { smartDocEHRParam_EHRTypeLabelMap, smartDocEHRParam_EHRTypes } from '@app/advisor-content-shared';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { DefaultEditor_InputText_Optional } from '@app/styles/frontend/ui-manager/ui-components';
const viewMode_View = 'view';
const viewMode_Edit = 'edit';
export class Editor_SmartDocParam_EHR extends ComponentSync {
    // ######################## Lifecycle ########################
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? viewMode_Edit : viewMode_View;
    // ######################## Render ########################
    render() {
        return _jsx(_Fragment, { children: this.render_Resolvers() });
    }
    render_Resolvers = () => {
        const resolvers = this.state.editable.editProp('resolver', {});
        return _jsxs(_Fragment, { children: [_jsx(LL_H_C, { className: 'editor__smart-doc-param__row', children: _jsx("div", { className: 'editor__smart-doc-param__header', children: "With resolvers:" }) }), smartDocEHRParam_EHRTypes.map(ehrType => this.render_Resolver(ehrType, resolvers))] });
    };
    render_Resolver = (ehrType, editable) => {
        return _jsxs(LL_H_C, { className: 'editor__smart-doc-param__row indent', children: [_jsx("div", { className: 'editor__smart-doc-param__header', children: smartDocEHRParam_EHRTypeLabelMap[ehrType] }), _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                        { key: viewMode_View, renderer: () => _jsx("div", { className: 'editor__smart-doc-param__value', children: _jsx("b", { children: editable.item[ehrType] ?? 'N/A' }) }) },
                        { key: viewMode_Edit, renderer: () => _jsx(DefaultEditor_InputText_Optional, { editable: editable, prop: ehrType }) }
                    ] })] });
    };
}
//# sourceMappingURL=Editor_SmartDocParam_EHR.js.map